import { Action, Dispatch } from 'redux'
import { fetchUsersAction } from 'reducks/user/actions'
import { fetchUser } from 'repos/user'
import { UserType } from 'types/user'

const fetchUsers = (userIds: string[]) => {
  return async (dispatch: Dispatch<Action>) => {
    const promises = userIds.map((uid) => fetchUser(uid))
    const users = await Promise.all(promises)
    if (users.some((user) => user instanceof Error)) {
      console.error('ユーザーの取得に失敗しました')
      return
    } else {
      dispatch(fetchUsersAction(users as UserType[]))
    }
  }
}

export default fetchUsers
